document.addEventListener('DOMContentLoaded', () => {

  const forms = document.querySelectorAll('[data-catalogue-form]');

  forms.forEach((form) => {

    form.addEventListener('submit', function(event) {

      event.preventDefault();

      const email =
        form.querySelector('[data-field="email"]')
          .value
          .trim();

      if (!email) {

        alert('Please enter your email');

        return;

      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {

        alert('Please enter valid email');

        return;

      }

      const submitBtn =
        form.querySelector('button[type="submit"]');

      if (submitBtn) {

        submitBtn.disabled = true;

        submitBtn.textContent = 'Submitting...';

      }

      const categoryInput = form.querySelector('[data-field="category"]');
      const category = categoryInput ? categoryInput.value : '';

      const downloadUrlInput = form.querySelector('[data-field="download-url"]');
      const downloadUrl = downloadUrlInput ? downloadUrlInput.value : '';

      const formData = new FormData();
      formData.append('email', email);
      formData.append('category', category);
      formData.append('source', 'catalogue-download');

      const googleScriptUrl = form.getAttribute('data-google-script-url') || 'https://script.google.com/macros/s/AKfycby6zvWT_oIcqdFpv0sTFhGRErBi0SVWEdtdaZwKATCdApuBkp7VsA1zJY6GsvT6xPNTRg/exec';

      function handleSuccess() {

        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Download Now';
        }

        const modal = form.closest('[class*="catalogue-modal"]');
        if (modal) {
          modal.classList.remove('active');
        }

        document.body.style.overflow = '';

        if (downloadUrl) {
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.target = '_blank';
          link.download = '';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }

      // Submit lead to Google Sheets and handle download/modal closure
      fetch(googleScriptUrl, {
        method: 'POST',
        mode: 'no-cors',
        body: formData
      })
      .then(() => {
        handleSuccess();
      })
      .catch((error) => {
        console.warn('Google Sheet submission warning:', error);
        // Even if the network submission fails, we still let them download the catalog
        handleSuccess();
      });

    });

  });
});